import { createSlice }         from '@reduxjs/toolkit';
import * as appUserReducers    from 'Redux/Reducers/AppUser';
import { AppUser }             from 'Domain/Models/AppUser/AppUser';
import { TAppUserOrganisation } from 'Domain/Repositories/AppUserRepository/AppUserRepository';

export interface IAppUserState {
  openRequests: string[],
  failedRequests: string[],
  updatedAt: number,
  entries: Record<string, AppUser>,
  searchEntries: Record<string, AppUser>,
  lastUpdateId: string | null,
  maxCount: number,
  organisations: TAppUserOrganisation[],
  assignedEventIdsByOrganisation: Record<string, string[]>,
}

export const appUserSlice = createSlice({
  name: 'appUser',
  initialState: {
    openRequests: [],
    failedRequests: [],
    entries: {},
    searchEntries: {},
    maxCount: 0,
    lastUpdateId: null,
    updatedAt: 0,
    organisations: [],
    assignedEventIdsByOrganisation: {},
  },
  reducers: appUserReducers,
});
